import {
  IntegrationChannelType,
  IntegrationInputData,
} from 'generated/graphql';

interface GetOAuthIntegrationOptions {
  channelType: IntegrationChannelType;
  authCode: string;
  clientID: string;
  clientSecret: string;
  dataCenter: string;
  subDomain: string;
  accountsServer: string;
  redirectUri: string;
}

export const getOAuthIntegrationDataInput = ({
  channelType,
  authCode,
  clientID,
  clientSecret,
  dataCenter,
  subDomain,
  accountsServer,
  redirectUri,
}: GetOAuthIntegrationOptions): IntegrationInputData => {
  const redirectUriRoute = `${window.location.origin}${redirectUri}`;

  switch (channelType) {
    case IntegrationChannelType.Slack:
      return {
        slack: {
          authGrant: authCode,
          redirectURI: redirectUriRoute,
        },
      };
    case IntegrationChannelType.Intercom:
      return {
        intercom: {
          authGrant: authCode,
        },
      };
    case IntegrationChannelType.ZendeskChat:
      return {
        zendeskChat: {
          accessToken: authCode,
          subDomain: subDomain ?? '',
        },
      };
    case IntegrationChannelType.ZendeskSupport:
      return {
        zendeskSupport: {
          authCode,
          subDomain: subDomain ?? '',
          redirectURI: redirectUriRoute,
        },
      };
    case IntegrationChannelType.Livechat:
      return {
        livechat: {
          authGrant: authCode,
          redirectURI: redirectUriRoute,
        },
      };
    case IntegrationChannelType.SurveyMonkey:
      return {
        surveyMonkey: {
          authCode,
          redirectURI: redirectUriRoute,
        },
      };
    case IntegrationChannelType.ZohoDesk:
      return {
        zohoDesk: {
          authCode,
          redirectURI: redirectUriRoute,
          topLevelDomain: subDomain ?? '',
          accountsServer: accountsServer ?? '',
        },
      };
    case IntegrationChannelType.Typeform:
      return {
        typeform: {
          authCode,
          redirectURI: redirectUriRoute,
        },
      };
    case IntegrationChannelType.Salesforce:
      return {
        salesforce: {
          authGrant: authCode,
          redirectURI: redirectUriRoute,
        },
      };
    case IntegrationChannelType.Discord:
      return {
        discord: {
          authGrant: authCode,
          redirectURI: redirectUriRoute,
        },
      };
    case IntegrationChannelType.Gong:
      return {
        gong: {
          authCode,
          redirectURI: redirectUriRoute,
        },
      };
    case IntegrationChannelType.Grain:
      return {
        grain: {
          code: authCode,
        },
      };
    case IntegrationChannelType.FacebookPages:
      return {
        facebookPages: {
          code: authCode,
          redirectURI: redirectUriRoute,
        },
      };
    case IntegrationChannelType.GoogleMyBusiness:
      return {
        googleMyBusiness: {
          code: authCode,
          redirectURI: redirectUriRoute,
        },
      };
    case IntegrationChannelType.Reddit: {
      return {
        reddit: {
          code: authCode,
        },
      };
    }
    case IntegrationChannelType.Qualtrics: {
      return {
        qualtrics: {
          code: authCode,
          clientID,
          clientSecret,
          datacenter: dataCenter,
          redirectURI: redirectUriRoute,
        },
      };
    }
    case IntegrationChannelType.Instagram: {
      return {
        instagram: {
          code: authCode,
          redirectURI: redirectUriRoute,
        },
      };
    }
    default:
      return {};
  }
};
